<template>
  <div class="track-container" ref="componentFocusTarget">

    <span class="curved-image">
      <img src="../assets/header-image.jpg" alt="header image">
      <span  class="curved-image__curve"></span>
    </span>

    <div class="track-container__inner">
      <h1>Benchmark Calculator</h1>
      <!-- Calculator has been decommissioned -->
      <h2>Page no longer available</h2>
      <div>
        Thank you for visiting! We appreciate your interest, but unfortunately, the page you are looking for is no longer available. We apologise for the inconvenience. To help you find what you need, please feel free to return to the <a href="https://www.csc.gov.au/">CSC website</a>.
      </div>

      <!-- Calculator has been decommissioned -->
      <!-- <p class="txt-left">
        Enter your details in the CSC Benchmark calculator to see how your super balance compares to your peers. If your balance is higher, you’re on the right track. If your balance is lower, find out how you can make additional contributions. 
      </p>
      <p class="txt-left">
        You’ll need to input your current super balance, which you can find on your annual statement, in your online account, or in the ATO section of your MyGov account.
      </p>

      <div class="terms-block">
        <h2>Accept terms and conditions of use</h2>
        <p>The CSC Benchmark calculator provides a snapshot in time and does not take into account your personal needs, circumstances and objectives.</p>
        <p>By using this benchmark calculator you are acknowledging the <router-link to="/disclaimer">Disclaimer and Assumptions</router-link>.</p>
      </div>

      <router-link to="/details" class="button">Continue</router-link> -->
    </div>

  </div>
</template>

<script>
export default {
  name: 'Welcome',
  methods: {
    track () {
      this.$ga.page('/')
    }
  }
}
</script>